
<body data-spy="scroll" data-target=".fixed-top">
 
 <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo --> 
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

           <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation" data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button> 

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll" routerLink="/" >Home <span class="sr-only">(current)</span></a>
                    </li>
                    
                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll"   (click)="gotoScroll('intro')">Intro</a>
                    </li>
                     <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll"   (click)="gotoScroll('details')">How it Works</a>
                    </li> 
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"   (click)="gotoScroll('features')">Features</a>
                    </li>
                   
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/contact-us" class="nav-link page-scroll"  href="javascript:void(0)"  >Contact Us </a>
                    </li>
                    <li class="nav-item" *ngIf="!user" >
                        <a routerLink="/faqs" class="nav-link page-scroll"  href="javascript:void(0)"   >FAQ's</a>
                    </li> -->
                  <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                     <!-- <li class="nav-item" *ngIf="this.extra" >
                            <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                            <a  routerLink="/account/login"  class="btn-solid-sm page-scroll" href="">Login</a>
                     </li>
                     <li class="nav-item" *ngIf="!this.extra"  >
                        <a  routerLink=""   class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login"   class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                     </li>
                </ul>
                -->
                 <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav>  -->



<app-public-navbar></app-public-navbar>
    
    <div class="feature-container">
        <div class="top-container">
        <img src="assets/newImages/feature.png" alt="" style="width: 100%;">
        <div class="heading-container">
            <h3>Unmatched Features. Unbeatable Benefits.
                <br/></h3>
                <h5 style="text-align: center;">For Buyers and Creators</h5>

            <p style="text-align: center;">
•	Global catalogue across formats and territories
• ⁠Verified buyers & sellers<br/>
•	End to end digital licensing workflows
•	Market intelligence for smarter decisions</p>
            <div class="btn-container">
                <!-- <button class="btn1" ><a routerLink="/contact-us"> Request a demo</a></button> -->
                <button class="btn1" routerLink="/contact-us" > Request a demo</button>

                <!-- <button class="btn1">Show Library</button> -->
                <!-- <button class="btn2">Join Connekkt Xchange</button> -->
            </div>
        </div>
        </div>
        <div class="bottom-container">
             <div class="row">
                <div class="col-lg-12 box-container">

                     <!-- Card -->
                     <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="far fa-comments purple"></span> -->
                                 <img src="assets/newImages/create-list.png" alt="">
                            </div>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Create and List</h4>
                            <ul>
                                 <li>Register: Create a free account / signup.</li>
                            <li>Build your listing: Upload and build your content library.</li>
                            <li>Drive sales: sell your content to anyone, anywhere in the world</li>
                            
                            </ul>
                           <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->

                    <!-- Card -->
                    <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="fas fa-headphones-alt green"></span> -->
                                 <img src="assets/newImages/smart-search.png" alt="">
                            </div>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Smart Search</h4>
                            <ul>
 <li>Search enabled with meta descriptions </li>
                            <li>Build your selection across genres, regions, cast, directors, producers, and much more</li>
                           
                            </ul>
                            <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->

                    <!-- Card -->
                    <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="far fa-clipboard blue"></span> -->
                           <img src="assets/newImages/negotiate.png" alt="">
                            </div>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Negotiate</h4>
                            <ul>
 <li>Multiple tools for driving engagement between buyers and sellers - Chat, video conf, audio conf, message board</li>
                            <li>100% record keeping option for all workflow and conversations for audit and transparency purpose</li>
                            <li>Ability to export all records as an email </li>
                           
                            </ul>
                            <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->
<div  style="display: flex; width: 100%; align-items: center; justify-content: center;">
    <h3>Coming Soon</h3>
</div>
                     <!-- Card -->
                     <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="far fa-clipboard blue"></span> -->
                            <img src="assets/newImages/smart-contract.png" alt="">
                            </div>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Smart Contract</h4>
                            <ul>
<li>Upload your own contract</li>
                            <li>Use predefined templates if you don’t have any standard contract document</li>
                            <li>Build your own using our standard template by customizing it as per your need</li>
                         
                            </ul>
                               <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->

                     <!-- Card -->
                     <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="far fa-clipboard blue"></span> -->
                            <img src="assets/newImages/invoice.png" alt="">
                            </div>

                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Automated Invoice</h4>
                            <ul>
   <li>Raise PO from within the system</li>
                            <li>Use our system default templates if you don’t have any</li>
                            <li>Upload your own templates if you have</li>
                            <li>Inbuild Tax compliant algorithm</li>
                            </ul>
                         
                            <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->

                     <!-- Card -->
                     <div class="card col-lg-3">
                        <div class="card-icon-wrapper">
                            <div class="card-icon">
                                <!-- <span class="far fa-clipboard blue"></span> -->
                            <img src="assets/newImages/escrow.png" alt="">
                            </div>
                        </div>
                        <div class="card-body">
                            <h4 class="card-title">Escrow</h4>
                            <ul>
                            <li>Only platform in the content licensing market place that offers fully secure ESCROW facility for both buyers and sellers</li>

                            </ul>
                            <!-- <a class="read-more no-line" href="article.html">Learn more <span
                                    class="fas fa-long-arrow-alt-right"></span></a> -->
                        </div>
                    </div>
                    <!-- end of card -->

                    

                   

                </div> <!-- end of col -->
            </div>
        </div>
    </div>


 <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-col first">
                        <h6>About Connekkt Xchange</h6>
                        <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables publishers, studios, platforms, and distributors to seamlessly discover, license, distribute, and monetize content across global markets.
                        </p>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col second">
                        <h6>Useful Links</h6>
                        <ul class="list-unstyled li-space-lg p-small">
                            <li><a href="/terms&conditions">Terms & Conditions</a><br/> <a routerLink="/privacy-policy">Privacy
                                    Policy</a> <br><a routerLink="/faqs">FAQs</a> <br><a routerLink="/privacySettings">Cookie Preferences</a><br><a routerLink="/contact-us">Contact Us</a> </li>
                            <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                    href="#">Illustrations</a></li>
                            <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                    href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                    class="page-scroll" href="#details">Details</a></li> -->
                                
                        </ul>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col third">
                        <span class="fa-stack">
                            <a href="#your-link">
                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                                 <img class="footer-img" src="assets/newImages/twitter.png" alt="">

                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">
                                
                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <p class="p-small">We would love to hear from you <a
                                href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                                <br/>
                                <!-- <a
                                    href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a></p> -->

                    </div> <!-- end of footer-col -->
                </div> <!-- end of col -->
            </div> <!-- end of row -->

             <!-- Copyright -->
    <div class="copyright">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                </div> <!-- end of col -->
            </div> <!-- enf of row -->
        </div> <!-- end of container -->
    </div> <!-- end of copyright -->
    
        </div> <!-- end of container -->
    </div>

    </body>
